import { render, staticRenderFns } from "./EndorsePolicy.vue?vue&type=template&id=3cf62a9a&"
import script from "./EndorsePolicy.vue?vue&type=script&lang=js&"
export * from "./EndorsePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports